import { Component } from '@angular/core';

@Component({
  selector: 'app-page-apoio-cultural',
  templateUrl: './page-apoio-cultural.component.html',
  styleUrls: ['./page-apoio-cultural.component.scss'],
})
export class PageApoioCulturalComponent {}
